<template>
  <div class="background_index_news">
    <div style="height: 92vh">
      <div style="padding-top: 32vh">
        <p style="font-size: 32px;margin-bottom: 0.5vh">Our Advantages</p>
        <p style="padding-top: 1vh">———</p>
        <p style="font-size: 24px">Over the past 15 years, SIG has focused on technology/media,</p>
        <p style="font-size: 24px">consumer/modern services, healthcare/green technologies.</p>
        <p style="font-size: 16px">We are interested in new business models, and we pay close
          attention to technology innovations,</p>
        <p style="font-size: 16px">but most important of all, we value the gift and potential of entrepreneurs.</p>
      </div>
      <div style="margin-top: 2vh">
        <a-button type="ghost">
          <router-link :to="'/news_en'" @click.passive="backtotop">See More News</router-link>
        </a-button>
      </div>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large" @click="next_page">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/";

export default {
  name: 'Index_news',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    return {next_page, backtotop}
  }
}

</script>
<style scoped>
.background_index_news {
  background-image: url("../../../assets/background/index_news.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  margin: 0;
}
.background_index_news p{
  margin-bottom: 0.5em
}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}
</style>